module.exports = __webpack_public_path__ + "img/clap.3b43e213.svg";